/** @format */

import { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AppBar from '../../Organisms/CustomAppBar';
import Sidebar, { DrawerHeader } from '../../Organisms/Sidebar/Sidebar';
import { Box, Container } from '@mui/material';
import BottomBar, { BTM_NAV_HEI } from '../../Organisms/BottomBar/BottomBar';
import { useUserInfo } from '../../../hooks/fetch/fetch.userInfo';
import PageSpinner from '../../Molecules/Spinner/PageSpinner';

import { useAppContext } from '../../../store/store.app';

function Index() {
  const navigate = useNavigate();
  const location = useLocation();

  useUserInfo();
  const {
    appStore: { userInfo },
  } = useAppContext();

  useEffect(() => {
    if (!userInfo || !userInfo.pages) return;

    const currentPath = location.pathname.replace(/\/$/, '');
    const enabledPages = userInfo.pages.filter((p) => p.display);
    // Find if current path is enabled
    const found = enabledPages.find(
      (page) =>
        currentPath === page.link ||
        currentPath === `/${page.link.replace(/^\//, '')}`
    );

    if (currentPath === '' || currentPath === '/') {
      // If root, redirect to first enabled page
      if (enabledPages.length > 0) {
        navigate(enabledPages[0].link);
      }
      return;
    }

    if (!found) {
      // If not found, redirect to first enabled page
      if (enabledPages.length > 0) {
        // navigate(enabledPages[0].link, { replace: true });
      }
    }
  }, [userInfo, navigate]);

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar />
      <Sidebar />
      <Container component="main" maxWidth={false}>
        <DrawerHeader className="no-print" />
        <Box sx={{ paddingBottom: { xs: BTM_NAV_HEI, md: '0px' } }}>
          <Suspense fallback={<PageSpinner />}>
            <Outlet />
          </Suspense>
        </Box>
        {/* <BottomBar /> */}
      </Container>
    </Box>
  );
}

export default Index;
